import templateUrl from "emun.order/order-list-grid.htm";
export default () => ({ templateUrl });
